// ABOUTME: Main layout component with collapsible sidebar
// ABOUTME: Provides consistent page structure across all dashboard views

import { useEffect, useState } from 'react';
import {
  getInitialSidebarCollapsed,
  setSidebarCollapsed as persistSidebarCollapsed,
} from '../lib/sidebar-prefs';
import { Sidebar } from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(getInitialSidebarCollapsed);

  useEffect(() => {
    persistSidebarCollapsed(sidebarCollapsed);
  }, [sidebarCollapsed]);

  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar
        isCollapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      {/* Main content area */}
      <main className={`transition-all duration-300 p-6 ${sidebarCollapsed ? 'ml-16' : 'ml-64'}`}>
        {children}
      </main>
    </div>
  );
}
